import React, { useContext, useState } from 'react';
import classnames from 'classnames';

import Config from '@skin_config';
import { useTranslation } from '@common/hooks/translation';
import NumericInput from '@common/components/numericInput';
import { PopupContext } from '@app/dev/contexts/popup';
import LazyImage from '../lazyImage';

export const CashoutMethods = () => {
  const t = useTranslation();
  const [{ openPopup, closePopup }] = useContext(PopupContext);

  const [activeMethod, setActiveMethod] = useState(Config.cashoutMethods[0]);
  const [amount, setAmount] = useState();
  const [error, setError] = useState('');

  const onContinue = async () => {
    if (!amount) return setError('Please set amount for cashout');

    openPopup(activeMethod.handlerPopup, { amount, cashoutMethod: activeMethod });

    setError('');
  };

  return (
    <div className="popup-content popup-small">
      <h3 className="popup-title">{t('Withdraw')}</h3>
      <div className="popup-main-content">
        {/* <i className="global-icon icon-cashout cashout-icon" /> */}
        <p className="text-center">{t('Please choose the withdraw method')}</p>
        <div className="deposit-methods">
          {Config.cashoutMethods.map((method) => (
            <div
              key={method.name}
              className={classnames('method', { active: method.type === activeMethod.type })}
              onClick={() => setActiveMethod(method)}
            >
              {method.pic ? <LazyImage name={method.pic} /> : <div>{method.name}</div>}
            </div>
          ))}
        </div>
        <div className="input-wrapper">
          <div className="popup-txt">{t('Withdraw Amount')}</div>
          <div className="input-row">
            <NumericInput className="numeric-input" onChange={(val) => setAmount(val)} value={amount} />
          </div>
          {error && (
            <div className="error-row" style={{ display: '' }}>
              <i className="global-icon icon-toast-error error-icon-cont" />
              <p className="error-row-text">{t(error)}</p>
            </div>
          )}
        </div>
      </div>

      <div className="popup-actions">
        <button onClick={closePopup} className="popup-cancel-button">
          {t('Cancel')}
        </button>
        <button onClick={onContinue} className="popup-confirm-button">
          {t('Continue')}
        </button>
      </div>
    </div>
  );
};
